import { render, staticRenderFns } from "./ChooseForm.vue?vue&type=template&id=335583d7&scoped=true"
import script from "./ChooseForm.vue?vue&type=script&lang=js"
export * from "./ChooseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335583d7",
  null
  
)

export default component.exports